import utils from '../utils'
import ZjLayoutContainer from './src/container.vue'
import ZjLayoutHeader from './src/header.vue'
import ZjLayoutMain from './src/main.vue'
import ZjLayoutFooter from './src/footer.vue'
import ZjLngLatSelect from './src/lnglatselect.vue'
import CameraPreview from './src/CameraPreview.vue'
import CameraPlayback from './src/CameraPlayback.vue'
import ElaryWarningBox from './src/ElaryWarningBox.vue'//预警弹窗提醒
import ZjDialog from './src/dialog.vue'
import HikCameraVideo from './src/HikCameraVideo.vue'
import FlvPlayer from './src/FlvPlayer.vue'
import FlvPlayerRealTime from './src/FlvPlayerRealTime.vue'
import FlvPlayerPlayback from './src/FlvPlayerPlayback.vue'
import FlvPlayerPlaybackNew from './src/FlvPlayerPlaybackNew.vue'
import VideoPlayer from './src/VideoPlayer.vue'
import barchart from './src/echart/BarEchart.vue'
import barchart2 from './src/echart/BarEchart2.vue'
import linechart from './src/echart/LineEchart.vue'
import GaugeEchart from './src/echart/GaugeEchart.vue'
import ChinaMapEchart from './src/echart/ChinaMapEchart.vue'
import EquipRightPanel from './src/EquipRightPanel.vue'
import MapView from './src/MapView.vue'
import RingPieEchart from './src/echart/RingPieEchart.vue'
import linechart2 from './src/echart/LineEchart2.vue'
import PieEchart from './src/echart/PieEchart.vue'
import BarEchart3 from './src/echart/BarEchart3.vue'
import PieEchart2 from './src/echart/PieEchart2.vue'
import LineEchart3 from './src/echart/LineEchart3.vue'
import ZJDragVerify from './src/dragVerify.vue'
import BarEchart4 from './src/echart/BarEchart4.vue'
import BarEchartTicket from './src/echart/BarEchartTicket.vue'
import LineEchartTicket from './src/echart/LineEchartTicket.vue'
import LineEchart2Ticket from './src/echart/LineEchart2Ticket.vue'
import LineEchartsTicket from './src/echart/LineEchartsTicket.vue'
import PieEchartTicket from './src/echart/PieEchartTicket.vue'
import PieEchartsTicket from './src/echart/PieEchartsTicket.vue'
import DictTag from './DictTag/index.vue'
import FlvPlayerRealTimeNew from './src/FlvPlayerRealTimeNew.vue'
import CardHegu from './src/controls/CardHegu.vue'
import CardHegu3 from './src/controls/CardHegu3.vue'
import TabHegu from './src/controls/TabHegu.vue'
import DayControlHegu from './src/controls/DayControlHegu.vue'

import BallCustom from './src/echart/BallCustom.vue'
import LineEchartsHegu from './src/echart/LineEchartsHegu.vue'
import HeguMapEchart from './src/echart/HeguMapEchart.vue'

import FlvPlayerRealTimeHegu from './src/FlvPlayerRealTimeHegu.vue'
import FlvPlayerRealTimeHeguGb from './src/FlvPlayerRealTimeHeguGb.vue'
const cmps = {
    ZjLayoutContainer,
    ZjLayoutHeader,
    ZjLayoutMain,
    ZjLayoutFooter,
    ZjLngLatSelect,
    CameraPreview,
    CameraPlayback,
    ElaryWarningBox,
    ZjDialog,
    HikCameraVideo,
    FlvPlayer,
    VideoPlayer,
    FlvPlayerRealTime,
    FlvPlayerPlayback,
    FlvPlayerPlaybackNew,
    barchart,
    barchart2,
    linechart,
    GaugeEchart,
    ChinaMapEchart,
    EquipRightPanel,
    MapView,
    RingPieEchart,
    linechart2,
    PieEchart,
    BarEchart3,
    PieEchart2,
    LineEchart3,
    ZJDragVerify,
    BarEchart4,
    BarEchartTicket,
    LineEchartTicket,
    LineEchart2Ticket,
    LineEchartsTicket,
    PieEchartTicket,
    PieEchartsTicket,
    DictTag,
    FlvPlayerRealTimeNew,
    CardHegu,
    CardHegu3,
    TabHegu,
    DayControlHegu,
    BallCustom,
    LineEchartsHegu,
    HeguMapEchart,
    FlvPlayerRealTimeHegu,
    FlvPlayerRealTimeHeguGb
}

const install = function (Vue) {
    utils.each(cmps, cmp => Vue.component(cmp.name, cmp))
}

export default {
    install,
    ...cmps
}